exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#variables-page-container{width:100%;padding:20px;background-color:#fff}#variables-page-container .custom-filter-dropdown{padding:8px;border-radius:6px;background:#fff;box-shadow:0 1px 6px rgba(0,0,0,.2)}#variables-page-container .custom-filter-dropdown input{width:130px;margin-right:8px}#variables-page-container .highlight{color:#f50}#variables-page-container .variables-page-content{margin-bottom:50px}#variables-page-container .variables-page-content .add-variables-btn{margin:15px;margin-top:0}#variables-page-container .variables-page-content .edit-cell button{width:80%;margin-left:10%}#variables-page-container .variables-page-content .delete-cell{width:100%;font-size:20px;color:red;text-align:center}#variables-page-container .variables-page-content .row{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/settings/monitoring/variables.scss
// module id = 2174
// module chunks = 43